// extracted by mini-css-extract-plugin
module.exports =  {"root":"MZvWLR1oGKgkaUjhllJC","content":"ONBlvAv9uuVr70ngoVc2"};